import React from "react";
import i18n from "i18next";
import { LuSearch, LuUpload, LuVideo } from "react-icons/lu";

export const LibraryHeader = ({ searchValue, onSearchChange }) => (
  <div className="add-video-modal__library-header">
    <div className="add-video-modal__library-search">
      <LuSearch className="add-video-modal__library-search-icon" />
      <input
        type="text"
        placeholder={i18n.t("search") || "Search"}
        value={searchValue}
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </div>
  </div>
);

export const LibraryEmptyState = ({ onUploadClick }) => (
  <div className="add-video-modal__library-empty">
    <div className="add-video-modal__library-empty-title">
      {i18n.t("FileModal.APIProviders.VideoGeneration.NoVideo") || "Video yok"}
    </div>
    <div className="add-video-modal__library-empty-subtitle">
      {i18n.t("FileModal.APIProviders.VideoGeneration.UploadPrompt") ||
        "Kendi videonu hemen yükleyebilirsin."}
    </div>
    <button
      type="button"
      className="add-video-modal__btn add-video-modal__btn--primary"
      onClick={onUploadClick}
      style={{ marginTop: 12 }}
    >
      <LuUpload style={{ marginRight: 6 }} />
      {i18n.t("FileModal.APIProviders.VideoGeneration.UploadNow") || "Hemen yükle"}
    </button>
  </div>
);

export const LibraryGrid = ({ files, selectedId, hoveredId, onSelect, onHover, onAdd }) => (
  <div className="add-video-modal__library-grid">
    {files.map((file) => (
      <div
        key={file.id}
        className={`add-video-modal__library-card${
          selectedId === file.id ? " add-video-modal__library-card--active" : ""
        }`}
        onClick={() => onSelect(file.id)}
        onMouseEnter={() => onHover(file.id)}
        onMouseLeave={() => onHover((current) => (current === file.id ? null : current))}
        onDoubleClick={() => {
          if (file.url) {
            onAdd(file.url, file.name);
          }
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 6,
            right: 6,
            display: "flex",
            gap: 4,
            zIndex: 5,
            opacity: hoveredId === file.id ? 1 : 0,
            pointerEvents: hoveredId === file.id ? "auto" : "none",
            transition: "opacity 150ms ease-out",
          }}
        >
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              if (file.url) {
                onAdd(file.url, file.name);
              }
            }}
            title={i18n.t("FileModal.APIProviders.VideoGeneration.AddToScene")}
            style={{
              width: 26,
              height: 26,
              borderRadius: 999,
              border: "1px solid #e5e7eb",
              backgroundColor: "rgba(255,255,255,0.95)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              stroke="#4b5563"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            >
              <rect x="4" y="4" width="16" height="16" rx="3" ry="3" />
              <line x1="12" y1="8" x2="12" y2="16" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
          </button>
        </div>

        <div className="add-video-modal__library-thumb">
          {file.url ? <video src={file.url} muted preload="metadata" /> : <LuVideo />}
        </div>
        <div
          className="add-video-modal__library-name"
          style={{
            fontSize: "11px",
            color: "#9ca3af",
            fontWeight: 400,
          }}
          title={file.name}
        >
          {file.name}
        </div>
      </div>
    ))}
  </div>
);
